import { tsUtils } from '@neo-one/ts-utils';
import { Types } from '../../constants';
import { IsHelper } from './IsHelper';
import { UnwrapHelper } from './UnwrapHelper';
import { WrapHelper } from './WrapHelper';
export class UnwrapBlockHelper extends UnwrapHelper {
}
export class WrapBlockHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Block;
    }
}
export class IsBlockHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Block;
    }
}
export const hasBlock = (context, node, type) => tsUtils.type_.hasType(type, (tpe) => isBlock(context, node, tpe));
export const isOnlyBlock = (context, node, type) => tsUtils.type_.isOnlyType(type, (tpe) => isBlock(context, node, tpe));
export const isBlock = (context, node, type) => context.builtins.isInterface(node, type, 'Block');

//# sourceMappingURL=block.js.map
